<div class="ticket-info" [formGroup]="busquedaForm">
  <div class="inputControl calendar">
    <a class="prev" title="Previo" (click)="backDia()">
      <img class="svg" src="assets/img/active-arrow.svg" alt="icono prev" />
    </a>
    <input
      type="text"
      formControlName="fecha"
      (click)="openModal('datePick')"
    />
    <a class="next" title="Próximo" (click)="nextDia()">
      <img class="svg" src="assets/img/active-arrow.svg" alt="icono next" />
    </a>
  </div>
  <div class="inputControl" (click)="openModal('clientSearch')">
    <input
      class="cliente"
      formControlName="cliente"
      type="text"
      placeholder="{{ 'CLIENTE' | translate }}"
    />
    <img class="svg" src="assets/img/icon-search.svg" alt="icono cliente" />
  </div>
</div>
<ng-container *ngIf="entradas">
  <div class="seleccionEntradasWrap">
    <div class="seleccionEntradas">
      <ng-container *ngFor="let entrada of pagedItems">
        <div
          *ngIf="entrada; else void"
          [ngClass]="{
            active:
              getCantidadPorEntrada(entrada) > 0 &&
              entradaSeleccionada !== entrada,
            select: entradaSeleccionada === entrada
          }"
          (click)="seleccionarEntrada(entrada)"
          class="Rtable-cell entrada-cell"
        >
          <div class="Rtable-cell--content entrada-nombre">
            {{ entrada.NombrePantalla }}
          </div>
          <div class="Rtable-cell--content entrada-precio">
            {{
              entrada.PrecioEnDivisaReferencia
                | myCurrency
                  : divisaSimboloDecimal
                  : divisaDecimales
                  : divisaPosicion
                  : divisaSimbolo
                  : divisaSimboloDerecha
                  : divisaSimbSeparacionMiles
            }}
          </div>
          <div class="Rtable-cell--content entrada-cantidad">
            ({{ getCantidadPorEntrada(entrada) }})
          </div>
          <input
            style="visibility: hidden; display: none"
            id="btn-{{ entrada.idTarifa }}"
            value="{{ getCantidadPorEntrada(entrada) }}"
            type="number"
            class="qty text"
            step="1"
            min="0"
            name="quantity"
            category="CANTIDAD"
          />
        </div>
        <ng-template #void>
          <div class="Rtable-cell entrada-cell" style="border: none">
            <div class="Rtable-cell--content entrada-nombre"></div>
            <div class="Rtable-cell--content entrada-precio"></div>
            <div class="Rtable-cell--content entrada-cantidad"></div>
          </div>
        </ng-template>
      </ng-container>
    </div>
  </div>

  <div class="SelecEntrPag">
    <ul class="pagination" *ngIf="pager.pages && pager.pages.length > 1">
      <li>
        <a (click)="setPage(pager.currentPage - 1)" title="Previo">
          <img class="svg" src="assets/img/active-arrow.svg" alt="icono prev" />
        </a>
      </li>
      <li *ngFor="let page of pager.pages">
        <a
          (click)="setPage(page)"
          [ngClass]="{ active: pager.currentPage === page }"
          >{{ page }}</a
        >
      </li>
      <li>
        <a (click)="setPage(pager.currentPage + 1)" title="Próximo">
          <img class="svg" src="assets/img/active-arrow.svg" alt="icono next" />
        </a>
      </li>
    </ul>
  </div>
</ng-container>
<ticketing-modal-selector-motivos
  class="backModal enMotivos"
  id="selector-motivos"
  style="display: none"
></ticketing-modal-selector-motivos>
<ticketing-selector-mas-entradas
  class="backModal enMotivos"
  id="selector-mas-entradas"
  style="display: none"
></ticketing-selector-mas-entradas>
